import { InjectionToken } from '@angular/core';
import { IFilterProvider } from './ifilter-provider';

export const FilterProvidersToken = new InjectionToken<IFilterProvider<any>>('Token')
